<template>
  <div class="home">
    <Header
      v-if="signed"
      :key="'header-' + headerKey"
      :style="styleHeader()"
      class="home-header"
      @headerChange="changeScreen"
      v-bind:section="selectedCategory"
    />
    <div style="margin-top: 70px" v-if="signed" class="router-view">
      <slot></slot>
    </div>
    <div v-else class="router-view-non-signed">
      <slot></slot>
    </div>
    <notifications-vue />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import NotificationsVue from './components/shared/notifications/Notifications.vue'
import { auth } from './Firebase'

export default {
  name: 'Home',
  components: {
    Header,
    NotificationsVue
  },
  mounted() {
    auth.onAuthStateChanged((user) => {
      if (
        user &&
        this.$router.history.current.name != 'signin' &&
        this.$router.history.current.name != 'notfound'
      ) {
        this.signed = true
      } else if (user) {
        this.signed = true
        this.$router.replace('/')
      } else {
        this.signed = false
      }
    })
  },
  data() {
    return {
      selectedHeader: 1,
      selectedCategory: 'Rentals',
      signed: false,
      username: '',
      headerKey: 0,
      sidebarKey: 0,
      contentKey: 0,
      vh: 0,
      vw: 0
    }
  },
  methods: {
    styleSidebar() {
      if (this.vw > 768) {
        return {
          width: `${this.vw * 0.16}px`,
          height: `${this.vh - 36}px`
        }
      }
    },
    styleHeader() {
      if (this.vw > 768) {
        return {
          left: `${this.vw * 0.16}px`,
          width: `${this.vw * 0.84}px`
        }
      }
    },
    styleContent() {
      let aux = this.vw * 0.16
      if (aux < 150) {
        aux = 150
      }

      return {
        width: `${this.vw * 0.84}px`,
        left: `${aux}px`,
        height: `${this.vh - 80}px`
      }
    },
    resize() {
      this.vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      )
      this.vh = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      )
    },
    changeScreen(screen) {
      this.selectedHeader = screen
    },
    changeCategory(category) {
      this.selectedCategory = category
      this.selectedHeader = 1
    }
  },
  created() {
    // this.$router.replace({ path: "/rentals" });
    window.addEventListener('resize', this.resize)
    auth.onAuthStateChanged((user) => {
      this.signed = user ? true : false
      if (
        this.$router.history.current.name != 'signin' ||
        this.$router.history.current.name != 'notfound'
      ) {
        this.signed = false
      }
      this.username = user.email // lookup the username later using email
    })
    this.resize()
  },
  destroyed() {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>
.router-view {
  margin-top: 25px;
  margin-left: 15%;
  height: 100% !important;
}
.router-view-non-signed {
  height: 100% !important;
}
.home {
  height: 100%;
  position: relative;
  background-color: #f5f6f8;
  overflow: hidden;
}

.home-header {
  height: 70px;
  top: 0;
  position: fixed;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  background-color: white;
}

.home-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 160px;
}

.home-content-container {
  height: 100%;
  background-color: #f5f6f8;
}

@media only screen and (max-width: 768px) {
  .home-header {
    height: 70px;
    top: 70px;
    width: 100%;
    left: 0;
  }

  .router-view {
    margin-left: 0;
  }
}
</style>
